exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-button[data-v-72ceee0b] {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n}\n", ""]);

// exports
